import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-route-dialog',
  templateUrl: './route-dialog.component.html',
  styleUrls: ['./route-dialog.component.css']
})
export class RouteDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
